module.exports = __webpack_public_path__ + "img/marina.7a25b174.png";